// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import PropTypes from 'prop-types';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Rating from '@mui/material/Rating';
import { alpha, styled } from '@mui/material/styles';
import { Box, Link, Card, Grid, Avatar, Typography, CardContent } from '@mui/material';
// utils
import { fDate } from '../../../utils/formatTime';
import { fShortenNumber } from '../../../utils/formatNumber';
//
import SvgIconStyle from '../../../components/SvgIconStyle';
import Iconify from '../../../components/Iconify';
import Paper from '@mui/material/Paper';
// ----------------------------------------------------------------------

const CardMediaStyle = styled('div')({
  position: 'relative',
  paddingTop: 'calc(100% * 3 / 4)',
});

const TitleStyle = styled(Link)({
  height: 44,
  overflow: 'hidden',
  WebkitLineClamp: 2,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
});

const AvatarStyle = styled(Avatar)(({ theme }) => ({
  zIndex: 9,
  width: 32,
  height: 32,
  position: 'absolute',
  left: theme.spacing(3),
  bottom: theme.spacing(-2),
}));

const InfoStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  marginTop: theme.spacing(3),
  color: theme.palette.text.disabled,
  flexDirection: 'column',
}));

const CoverImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

SpacePostCardVendor.propTypes = {
  post: PropTypes.object.isRequired,
};

export default function SpacePostCardVendor({ post }) {
  const navigate = useNavigate();
console.log(post,"post")
  const { id, name, cover, view, comment,vehicleDetailObj, totalRevenue, author, createdAt } = post;
  const latestPostLarge = id === 0;
  const latestPost = id === 1 || id === 2;

  return (
    <Grid item xs={2} sm={4} md={4}>
      <Card sx={{ position: 'relative' }}>
        <CardContent>
          <TitleStyle
            color="inherit"
            variant="h4"
            underline="hover"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate('/dashboard/vehiclewisedata', {
                state: {
                  id: id,
                  data: post,
                },
              });
            }}
          >
            {vehicleDetailObj?.registrationNumber}
          </TitleStyle>
            <Typography variant="h6">
                <span sx={{ color: 'common.white' }}>{vehicleDetailObj?.model}</span>
            </Typography>
          <InfoStyle>
            <Typography variant="h3" component="h4">
              ₹ <span sx={{ color: 'common.white' }}>{fShortenNumber(totalRevenue)}</span>
            </Typography>
          </InfoStyle>
        </CardContent>
      </Card>
    </Grid>
  );
}
